import { 
  SET_TIPOS_GRUPO_PLANES,
  SET_TIPOS_PUBLICACION,
  FETCH_TIPOS_PUBLICACION,
  FETCH_TIPOS_PUBLICACION_BYID,
  LOADING_TIPOS_PUBLICACION,
  SET_LIMPIAR_FILTRO_TIPOS_PUBLICACION,
  RESET_FILTRO_TIPOS_PUBLICACION,
  SET_FILTRO_TIPOS_PUBLICACION,
  RESET_TIPOS_PUBLICACION,
  RESET_VALUE_CHECKED,
  RESET_SET_TIPO_PUBLICACIONES,
  UPDATE_LIST_TIPOS_PUBLICACIONES,
  IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB
} from './types';
import { getTiposPublicacion, fetchTipoPublicacionApi } from '../api/axios';


export const fetchTiposPublicacion = (idSeller) => async dispatch => {
    const req = fetchTipoPublicacionApi(idSeller);
    req.then((tipos) => {

        dispatch({
            type: IS_LOADED_TIPO_PUBLICACION_IN_SELLER_TAB,
            payload: true
        });

        dispatch({
            type: SET_TIPOS_PUBLICACION,
            payload: tipos.tiposPublicaciones
        });
    })
}

export const setTiposPublicacion = (params) => async dispatch => {

  dispatch({
    type: SET_TIPOS_PUBLICACION,
    payload: params,
  });
}

 export const resetSetTiposPublicaciones = (object) => async dispatch => {
   dispatch({
     type: RESET_SET_TIPO_PUBLICACIONES,
     payload: object
   })
 }

export const resetValueChecked  = () => async dispatch => {
  dispatch({
    type: RESET_VALUE_CHECKED,
    payload: [],
  });
}

export const setFiltroTipoPublicaciones = () => async dispatch => {

  dispatch({
    type: SET_FILTRO_TIPOS_PUBLICACION,
    payload: [],
  });
}

export const resetTipoPublicaciones = () => async dispatch => {

  dispatch({
    type: RESET_TIPOS_PUBLICACION,
    payload: [],
  });
}



export const setTiposGrupoPlanes = (params) => async dispatch => {

  dispatch({
    type: SET_TIPOS_GRUPO_PLANES,
    payload: params,
  });
}
export const setFiltroTiposPublicacion = (filtro)=> async dispatch => {
  dispatch({
    type: SET_FILTRO_TIPOS_PUBLICACION,
    payload: filtro,
  });
}

export const resetTiposPublicacion = (filtro)=> async dispatch => {
  dispatch({
    type: RESET_FILTRO_TIPOS_PUBLICACION,
    payload: filtro,
  });
}

export const fetchTiposPublicacionAdm = (request) => async dispatch => { 
  dispatch({
    type: LOADING_TIPOS_PUBLICACION,
    payload: true
  });

  try {
    const response = await getTiposPublicacion(request);
    dispatch({
      type: FETCH_TIPOS_PUBLICACION,
      payload: response
    });
    return response;
  } catch (error) {
  } finally {
    dispatch({
      type: LOADING_TIPOS_PUBLICACION,
      payload: false
    });
  }
}


export const fetchTiposPublicacionAdmById = (request) => async dispatch => {
  dispatch({
    type: LOADING_TIPOS_PUBLICACION,
    payload: true
  });

  let array = getTiposPublicacion(request);
  array.then((value) => {

    dispatch({
      type: LOADING_TIPOS_PUBLICACION,
      payload: false
    });

    dispatch({
      type: FETCH_TIPOS_PUBLICACION_BYID,
      payload: value
    });
  })
}

export const updateListTiposPublicaciones = (tiposPublicacionesArray, tipoPublicacion) => async dispatch => {
    // Transformar `tipoPublicacion` para que `idTipoPublicacion` sea `codigo` y elimino idTipoPublicacion
    const tipoPublicacionTransformada = {
        ...tipoPublicacion,
        codigo: tipoPublicacion.idTipoPublicacion, 
    };
    delete tipoPublicacionTransformada.idTipoPublicacion;

    //existe un elemento que cumpla con las condiciones
    const existe = tiposPublicacionesArray.elementos.some(item =>
        item.codigo === tipoPublicacionTransformada.codigo &&
        (item.descripcion !== tipoPublicacionTransformada.descripcion
            || item.comision !== tipoPublicacionTransformada.comision
            || item.cantidadCuotas !== tipoPublicacionTransformada.cantidadCuotas
        )
    );

    if (!existe) {
        return;
    }

    // Crear nuevo array actualizando el elemento correspondiente
    const elementosActualizados = tiposPublicacionesArray.elementos.map(item =>
        item.codigo === tipoPublicacionTransformada.codigo ? tipoPublicacionTransformada : item
    );

    // Crear una nueva copia del objeto Array con los elementos actualizados
    const updatedTiposPublicacionesArray = {
        ...tiposPublicacionesArray,
        elementos: elementosActualizados, 
    };

    dispatch({
        type: UPDATE_LIST_TIPOS_PUBLICACIONES,
        payload: updatedTiposPublicacionesArray
    });
};